export default () => ({
  all: [],
  promocodes: [],
  offers: [],
  totalRows: 0,
  count: 0,
});
